<template>
  <div class="form-group row" v-if="fbinvisible != 'true'">
      <div class="col-form-input col-sm-12" >
        <div class="form-check">
          <input type="checkbox" id="checkbox1" class="form-check-input" @change="dataChanged" ref="input" :value="value" :disabled="checkReadonly(isedit, fbreadonly)">
          <label class="form-check-label" for="checkbox1"><b style="color: red;" v-if="fbrequired == 'true'">*</b> {{fbsupportmultiplelanguages? $helper.getWord(fblabel) :fblabel }}</label>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  name: "CheckBoxMultiple",
  props: [
    "id",
    "fbsupportmultiplelanguages",
    "fblabel",
    "value",
    "fbvalue",
    "fboptions",
    "fbreadonly",
    "fbrequired",
    "labelwidth",
    "fbhidelabel",
    "helptext",
    "fbinvisible", 
    'isedit'
  ],
  data() {
    return {
      d: null,
      isValid: true,
      val: []
    };
  },
  mounted() {
    this.initCheckbox();

    this.val = this.fbvalue == 'true';  // Checkbox UI Value
    //(this.fbvalue == 'true')? this.d = this.fbvalue : this.d = null;  //vue componenet value
    this.$emit('input', this.fbvalue == 'true');  //vue componenet value
    $(this.$refs.input).prop('checked', this.fbvalue == 'true')
    //this.value = this.fbvalue == 'true';  //vue componenet value
    if(this.value != null){
      this.$emit('input', this.value == '1', this);
      $(this.$refs.input).prop('checked', this.value == '1')
    }

  },
  computed: {
    labelCol() {
      return this.labelwidth || 3;
    }
  },
  methods: {
    setFocus() {
      $(this.$el)
        .find(":checkbox")
        .filter(":first")
        .focus();
    },
    setValid(val) {
      this.isValid = val;
    },
    isFieldValid() {
      return (
        !this.required ||
        (this.required &&
          this.val !== null &&
          this.val !== undefined &&
          this.val.length !== 0)
      );
    },
    dataChanged(e) {
      if ($(e.target).is(":checked")) {
        this.d = $(e.target).val();
      } else {
        this.d = null;
      }
      this.$emit("input", $(e.target).is(":checked"));
    },
    resetValue() {
      this.isValid = true;
      $(this.$el)
        .find(":checkbox")
        .prop("checked", false);
    },
    initCheckbox() {
      // $(this.$refs.options)
      //   .find(".form-check-input-styled")
      //   .uniform({
      //     wrapperClass: "border-success-600 text-success-800"
      //   });
    },
    checkReadonly(isedit, fbreadonly){
      let readonly = true;
      if(isedit){
        if(fbreadonly == 'true'){
          readonly = true;
        }else{
          readonly = false;
        }

      }else{
        readonly = true;
      }
      return readonly;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.val = val;
      }
    },
    isiedit: function(){

    }
  }
};
</script>
